//DefaultTable

import * as React from 'react';
import { useNavigate } from 'react-router-dom'
import Box from '@mui/material/Box';
import { DataGrid, gridClasses } from '@mui/x-data-grid';
import { Button } from 'reactstrap';
import { alpha, styled } from '@mui/material/styles';
import { useIntl } from 'react-intl';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import Tooltip from '@mui/material/Tooltip';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

const ODD_OPACITY = 0.2;

const StripedDataGrid = styled(DataGrid)(({ theme }) => ({
    [`& .${gridClasses.row}.even`]: {
        backgroundColor: theme.palette.grey[200],
        '&:hover, &.Mui-hovered': {
            backgroundColor: alpha(theme.palette.primary.main, ODD_OPACITY),
            '@media (hover: none)': {
                backgroundColor: 'transparent',
            },
        },
        '&.Mui-selected': {
            backgroundColor: alpha(
                theme.palette.primary.main,
                ODD_OPACITY + theme.palette.action.selectedOpacity,
            ),
            '&:hover, &.Mui-hovered': {
                backgroundColor: alpha(
                    theme.palette.primary.main,
                    ODD_OPACITY +
                    theme.palette.action.selectedOpacity +
                    theme.palette.action.hoverOpacity,
                ),
                // Reset on touch devices, it doesn't add specificity
                '@media (hover: none)': {
                    backgroundColor: alpha(
                        theme.palette.primary.main,
                        ODD_OPACITY + theme.palette.action.selectedOpacity,
                    ),
                },
            },
        },
    },
}));



const keyField = 'vaporSemanalProveedor_Id';

export default function VaporesSemanalesProveedor_Table(props) {
    const [pageSize, setPageSize] = React.useState(10);
    const [rows, setRows] = React.useState(props.data);
    const [sortModel, setSortModel] = React.useState([
        {
            field: keyField,
            sort: 'desc',
        },
    ]);
    const intl = useIntl();
    const navigate = useNavigate();
    const columns = [
        {
            field: keyField,
            headerName: 'ID',
            width: 90,
            type: 'number',
            hide: true
        },
        {
            field: 'semana',
            headerName: intl.formatMessage({ id: 'Semana' }),
            editable: false,
            flex: 60,
        },
        {
            field: 'naviera',
            headerName: intl.formatMessage({ id: 'Naviera' }),
            editable: false,
            flex: 90,
        },
        {
            field: 'barcoViaje',
            headerName: intl.formatMessage({ id: 'Vapor' }),
            editable: false,
            flex: 180,
        },
        {
            field: 'identificativo',
            headerName: intl.formatMessage({ id: 'Identificativo' }),
            editable: false,
            flex: 180,
        },
        {
            field: 'contenedoresSemanales',
            headerName: intl.formatMessage({ id: 'Contenedores' }),
            editable: false,
            flex: 90,
        },
        {
            field: 'actions',
            headerName: '',
            sortable: false,
            editable: false,
            filterable: false,
            align: 'center',
            width: 240,
            renderCell: (params) => {
                return (
                    <div>
                        <Tooltip arrow placement="top" title={intl.formatMessage({ id: "Contenedores" })}>
                            <IconButton className="DarkTealButton GridButton" onClick={() => {
                                navigate('/VaporesSemanales/' + params.row[keyField] + '/ContenedoresSemanales');
                            }}>
                                <LocalShippingOutlinedIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip arrow placement="top" title={intl.formatMessage({ id: "BLs" })}>
                            <IconButton className="BurntSiennaButton  GridButton" onClick={() => {
                                navigate('/VaporesSemanales/' + params.row[keyField] + '/BLs');
                            }}>
                                <ReceiptLongIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Editar">
                            <IconButton className='DarkBlueButton GridButton' onClick={() => {
                                props.edit_onclick(params.row[keyField])
                            }}>
                                <EditIcon />
                            </IconButton>
                        </Tooltip>
                        {params.row["contenedoresSemanales"] > 0 ?
                            <Tooltip arrow placement="top" title={intl.formatMessage({ id: "Existen elementos asociados a este item" })}>
                                <span>
                                    <IconButton disabled={params.row["contenedoresSemanales"] > 0} className='DisabledButton GridButton'>
                                        <DeleteIcon />
                                    </IconButton>
                                </span>
                            </Tooltip> :
                            <Tooltip arrow placement="top" title={intl.formatMessage({ id: "Eliminar" })}>
                                <IconButton disabled={params.row["contenedoresSemanales"] > 0} className='RedButton GridButton' onClick={() => {
                                    props.delete_onclick(params.row[keyField])
                                }}>
                                    <DeleteIcon />
                                </IconButton>
                            </Tooltip>}
                    </div>

                )
            },
        },

    ];
    const [columnVisibilityModel, setColumnVisibilityModel] = React.useState({
        vaporSemanalProveedor_Id: false,
    });
    return (
        <div>
            <Toolbar>
                <div className="row" style={{ width: '100%' }}>
                    <div className="col">
                        
                    </div>
                </div>
                <Button className="AddButton" style={{ whiteSpace: 'nowrap' }} onClick={() => {
                    props.add_onclick()
                }}><AddIcon /> Agregar</Button>
            </Toolbar>
            <Box sx={{
                height: 600, width: '100%',
            }}>

                <StripedDataGrid
                    rows={rows}
                    columns={columns}
                    pageSize={pageSize}
                    onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                    rowsPerPageOptions={[10, 20]}
                    pagination
                    disableRowSelectionOnClick
                    getRowClassName={(params) =>
                        params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
                    }
                    getRowId={(row) => row[keyField]}
                    sortModel={sortModel}
                    onSortModelChange={(newSortModel) => setSortModel(newSortModel)}

                    componentsProps={{
                        pagination: {
                            labelRowsPerPage: intl.formatMessage({ id: 'Resultados por pagina' }),
                            labelDisplayedRows: ({ from, to, count }) => `${from} - ${to} ${intl.formatMessage({ id: 'de' })} ${count}`,
                        }
                    }}

                    columnVisibilityModel={columnVisibilityModel}
                    onColumnVisibilityModelChange={(newModel) =>
                        setColumnVisibilityModel(newModel)
                    }
                />
            </Box>
        </div>
    );
}
